import { CallContactComponent } from '../../dialogs/call-contact/call-contact.component';
import { openDialog, openSnackbar } from 'app/store/actions/page.action';
import { Store } from '@ngrx/store';
import { ButtonSelectComponent } from '../../shared/ui/button-select/button-select.component';
import { DialogData } from '../../store/models/dialog.model';
import { InfoTipsComponent } from '../../dialogs/info-tips/info-tips.component';
import { Button } from '../../store/models/button.model';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { ETableColumnType, ITableColumn, ITableDataSource } from 'app/store/models/table.model';
import { ButtonColor, ButtonSize } from 'app/store/models/button.model';
import { LeftMenuService } from 'app/store/services/left-menu.service';
import { SessionService } from 'app/store/services/session.service';
import { ApiDataSource } from 'app/datasources/api.datasrouce';
import { takeUntil } from 'rxjs/operators';
import { UserType } from 'app/store/models/user.model';
import { HttpClient } from '@angular/common/http';
import { IVip } from 'app/store/models/vip.model';
import { EInfoSelectItemType } from 'app/store/models/select.model';
import { IReducers } from 'app/store/reducers';
import { environment } from '../../../environments/environment';
import { IContactItem } from '../../store/models/contact.model';
import { updateLeftMenuCount } from '../../store/actions/meeting.action';
import { ContactsService } from '../../store/services/contacts.service';
import { RContentComponent } from '../../dialogs/quick-response/r-content.component';
import { ContactActivityComponent } from '../../dialogs/contact-activity/contact-activity.component';
import { TableComponent } from '../../shared/ui/table/table.component';

@Component({
  selector: 'app-vip-listing',
  templateUrl: './vip-listing.component.html',
  styleUrls: ['./vip-listing.component.scss'],
})
export class VipListingComponent implements OnInit, OnDestroy {
  @ViewChild('tableComponent') tableComponent: TableComponent;
  tableDataSourceParams = {
    page: 1,
    pageSize: 10,
    sortAttr: 'action_data1',
    sortDir: 'desc',
    filters: {},
  };
  tableColumns: ITableColumn<IVip>[];
  dataSource: ITableDataSource;
  exportButtonProperties: Button = {
    onClick: () => console.log('here 1 export'),
    size: ButtonSize.SMALL,
    text: 'Export',
    color: ButtonColor.ORANGE,
  };
  tableReady: boolean;
  private destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private http: HttpClient,
    private leftMenu: LeftMenuService,
    private sessionService: SessionService,
    private store: Store<IReducers>,
    private readonly contactsService: ContactsService,
  ) {
    this.dataSource = new ApiDataSource<IVip>(
      this.http,
      environment.apiUrl + '/v1/messages/vip',
    );
    this.leftMenu.expand('inbox');
  }

  rowClass = () => ['route_message'];

  openSendEmailDialog(item, data) {
    this.store.dispatch(
      openDialog({
        dialogData: {
          title: data.label,
          content: RContentComponent,
          componentData: {
            data,
          },
          dialogMinWidth: '1000px',
          canClose: true,
          buttons: [
            {
              text: 'Ok',
              actAsClose: true,
              color: ButtonColor.GREEN,
              size: ButtonSize.NORMAL,
            },
            {
              text: 'Close',
              actAsClose: true,
              color: ButtonColor.RED,
              size: ButtonSize.NORMAL,
            },
          ],
        },
      }),
    );
  }

  openAddToCampaignDialog(item, data) {
    this.store.dispatch(
      openDialog({
        dialogData: {
          title: data.label,
          content: RContentComponent,
          componentData: {
            data,
          },
          dialogMinWidth: '1000px',
          canClose: true,
          buttons: [
            {
              text: 'Ok',
              actAsClose: true,
              color: ButtonColor.GREEN,
              size: ButtonSize.NORMAL,
            },
            {
              text: 'Close',
              actAsClose: true,
              color: ButtonColor.RED,
              size: ButtonSize.NORMAL,
              onClick: () => console.log('cska'),
            },
          ],
        },
      }),
    );
  }

  openItemDialog(itemRow, selectedItem) {
    switch (selectedItem.tag) {
      case 'main':
        break;
      case 'got-it':
        this.contactsService
          .quickResponse({ contact_id: itemRow.contact_id }, 'okgotit')
          .subscribe(response => {
            this.store.dispatch(updateLeftMenuCount({ data: {} }));
            console.log(response);
          });
        // v1/messages/okgotit
        break;
      case 'send-mail':
        this.openSendEmailDialog(itemRow, selectedItem);
        break;
      case 'send-to-campaign':
        this.openAddToCampaignDialog(itemRow, selectedItem);
        break;
      default:
        this.openDialog(itemRow, selectedItem);
        break;
    }
  }

  openDialog(item, data) {
    this.store.dispatch(
      openDialog({
        dialogData: {
          title: data.label,
          content: RContentComponent,
          componentData: {
            data,
            contact_id: item.contact_id,
          },
          dialogMinWidth: '1000px',
          canClose: true,
          tips: ['cycle', 'followup', 'meeting', 'inactive', 'remove'].indexOf(data.tag) !== -1 ? 'send-update' : null,
        },
      }),
    );
  }

  ngOnInit() {
    this.sessionService
      .onReady()
      .pipe(takeUntil(this.destroy$))
      .subscribe(sessionData => {
        let columns: ITableColumn<IVip>[] = [
          {
            id: 'contact_firstname',
            title: 'Contact',
            sortable: true,
            renderer: row => {
              return `${row.contact_firstname ? row.contact_firstname : ''} ${
                row.contact_lastname ? row.contact_lastname : ''
              }`;
            },
            route: (row: IVip) => `/user_contacts/${row.contact_id}/edit`,
          },
          {
            id: 'contact_company',
            title: 'Company',
            sortable: true,
          },
          {
            id: 'last_email',
            title: 'Last Email',
            sortable: true,
          },
          {
            id: 'contact_phone',
            title: 'Phone Number',
          },
          {
            id: 'activity',
            title: 'Activity',
            type: ETableColumnType.BUTTON,
            buttonProperties: {
              color: ButtonColor.ORANGE,
              text: 'Activity',
              size: ButtonSize.SMALL,
              style: 'outline',
              onClick: (item: IContactItem) =>
                this.store.dispatch(
                  openDialog({
                    dialogData: {
                      title: `Contact History for ${item.contact_firstname} ${item.contact_lastname}`,
                      content: ContactActivityComponent,
                      componentData: {
                        contactId: item.contact_id,
                        contactReplayAction: item.action_name,
                      },
                      dialogMinWidth: '1000px',
                      canClose: true,
                    },
                  }),
                ),
            },
          },
        ];


        columns = [
          ...columns,
          {
            id: 'response',
            title: 'Reply',
            type: ETableColumnType.COMPONENT,
            componentProperties: {
              component: ButtonSelectComponent,
              mapData: {
                buttonProperties: {
                  instance: 'static',
                  target: {
                    text: 'Reply',
                    size: ButtonSize.SMALL,
                    color: ButtonColor.ORANGE,
                  },
                },
                selection: {
                  instance: 'function',
                  target: rowItem => {
                    return selectItem =>
                      this.openItemDialog(rowItem, selectItem);
                  },
                },
                items: {
                  instance: 'function',
                  target: (item: IContactItem) => {
                    const targetItems = [
                      {
                        label: 'Opportunities',
                        type: EInfoSelectItemType.TYPE_LINK,
                        tag: 'main',
                        dialogContent: this.getDialogData('opportunities'),
                        children: [
                          {
                            label: 'Meetings',
                            tag: 'meeting',
                            type: EInfoSelectItemType.TYPE_LINK,
                            dialogContent: this.getDialogData('meeting'),
                          },
                          {
                            label: 'Order/Quote',
                            tag: 'order',
                            type: EInfoSelectItemType.TYPE_LINK,
                            dialogContent: this.getDialogData('order'),
                          },
                        ],
                      },
                      {
                        label: 'Cycle',
                        tag: 'cycle',
                        type: EInfoSelectItemType.TYPE_LINK,
                        dialogContent: this.getDialogData('cycle'),
                      },
                      {
                        label: 'Follow up',
                        tag: 'followup',
                        type: EInfoSelectItemType.TYPE_LINK,
                        dialogContent: this.getDialogData('follow_up'),
                      },
                      {
                        label: 'Inactive',
                        tag: 'inactive',
                        type: EInfoSelectItemType.TYPE_LINK,
                        dialogContent: this.getDialogData('inactive'),
                      },
                      {
                        label: 'Remove',
                        tag: 'remove',
                        type: EInfoSelectItemType.TYPE_LINK,
                        dialogContent: this.getDialogData('remove'),
                      },
                      {
                        label: 'Conversation',
                        tag: 'conversation',
                        type: EInfoSelectItemType.TYPE_LINK,
                        dialogContent: this.getDialogData('conversation'),
                      },
                    ];

                    if (sessionData.user_type === UserType.SINGLE_USER) {
                      targetItems.push({
                        label: 'Enter Activity',
                        tag: 'enter_activity',
                        type: EInfoSelectItemType.TYPE_LINK,
                        dialogContent: this.getDialogData('enter_activity'),
                      });
                    }

                    return targetItems;
                  },
                },
              },
            },
          },
          {
            id: 'make_call',
            type: ETableColumnType.BUTTON,
            title: 'Make Call',
            buttonProperties: {
              onClick: (element: IVip) =>
                this.store.dispatch(
                  openDialog({
                    dialogData: {
                      content: CallContactComponent,
                      canClose: true,
                      dialogMinWidth: '700px',
                      title: `Call ${element.contact_firstname} ${element.contact_lastname}`,
                      componentData: {
                        contact: element,
                      },
                      onClose: () => this.tableComponent.refresh()
                    },
                  }),
                ),
              text: 'Call',
              color: ButtonColor.GREEN,
              size: ButtonSize.SMALL,
              style: 'outline',
            },
          },
          {
            id: 'remove_vip',
            type: ETableColumnType.BUTTON,
            title: 'Remove VIP',
            buttonProperties: {
              onClick: (element: IVip) =>
                this.contactsService
                  .setContactVipStatus(element.contact_id, false)
                  .subscribe(result => {
                    this.store.dispatch(openSnackbar({
                      snackbarData: {
                        data: {
                          message: 'Message removed successfully.',
                          type: 'success'
                        }
                      }
                    }));
                    if (this.tableComponent) {
                      this.tableComponent.refresh();
                    }
                  }, err => this.store.dispatch(openSnackbar({
                    snackbarData: {
                      data: {
                        message: err.error,
                        type: 'error'
                      }
                    }
                  }))),
              text: 'Remove',
              color: ButtonColor.RED,
              size: ButtonSize.SMALL,
              style: 'outline',
            },
          },
        ];

        if (
          [UserType.MASTER, UserType.MANAGER, UserType.PARTNER].indexOf(
            sessionData.user_type,
          ) !== -1
        ) {
          columns.push({
            id: 'account_firstname',
            title:
              sessionData.user_type === UserType.MASTER
                ? 'Account'
                : 'Representative',
            sortable: true,
            renderer: row => {
              return `${row.account_firstname} ${row.account_lastname}`;
            },
          });
        }

        this.tableColumns = columns;
        this.tableReady = true;
      });
  }

  getDialogData(type): DialogData {
    return {
      content: InfoTipsComponent,
      title: 'Tips',
      canClose: true,
      dialogMinWidth: '700px',
      componentData: {
        type,
      },
    };
  }

  ngOnDestroy() {
    this.destroy$.next(false);
  }
}
